import { FC, useEffect, useState } from 'react';
import { ProductListingWithCacheProps } from '.';
import { useFetchProductsUsingRedis } from 'reactQuery/queries';
import { Styled } from '.';
import { ProductListingHeader } from 'components/ProductListingHeader';
import { SortDirection } from 'types';
import { FacetFilters, ProductListing } from 'components';
import { useApplyFacetFilterFromURL } from 'utils/hooks';
import AppliedFilterList from 'components/ProductListing/AppliedFilterList';
import { isNAStore } from 'utils';

const ProductListingWithRedisContainer: FC<ProductListingWithCacheProps> = ({
  taxonDetails,
}) => {
  const [sortDirection, setSortDirection] = useState<SortDirection | ''>('');

  const taxonSlug = taxonDetails.taxon.permalink;

  const {
    appliedFacetFilters,
    onSelectFacetFilter,
    onRemoveFacetFilter,
    onRemoveAllFacetFilter,
  } = useApplyFacetFilterFromURL();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [appliedFacetFilters]);

  const productListData = useFetchProductsUsingRedis({
    searchCriteria: {
      taxonSlug: taxonSlug,
    },
    filters: appliedFacetFilters,
    sortDirection: sortDirection,
  });

  const handleProductSorting = (sortType: SortDirection) => {
    setSortDirection(sortType);
  };

  useEffect(() => {
    if (isNAStore()) {
      setSortDirection(SortDirection.NewestFirst);
    } else {
      setSortDirection('');
    }
  }, [taxonSlug]);

  return (
    <>
      <ProductListingHeader
        title={taxonDetails.taxon.title}
        totalProductCount={productListData.data?.pages[0]?.totalCount}
        onSort={handleProductSorting}
        sortDirection={sortDirection}
        isLoading={productListData.isLoading || productListData.isIdle}
      />

      <AppliedFilterList
        allFilters={productListData.data?.pages[0]?.aggregations}
        appliedFilters={appliedFacetFilters}
        removeFilter={onRemoveFacetFilter}
        clearAllFilters={onRemoveAllFacetFilter}
        translations={productListData.data?.pages[0]?.translations}
      />
      <Styled.Main>
        <Styled.FilterWrapper>
          <Styled.FilterSectionSticky>
            {productListData.data?.pages[0]?.aggregations &&
              productListData.data?.pages[0]?.aggregations.length > 0 && (
                <FacetFilters
                  facetFilters={productListData.data?.pages[0]?.aggregations}
                  onChange={onSelectFacetFilter}
                  appliedFacetFilters={appliedFacetFilters}
                  translations={productListData.data?.pages[0]?.translations}
                />
              )}
          </Styled.FilterSectionSticky>
        </Styled.FilterWrapper>

        <Styled.ProductListingWrapper>
          <ProductListing productList={productListData} />
        </Styled.ProductListingWrapper>
      </Styled.Main>
    </>
  );
};

export default ProductListingWithRedisContainer;
